import { c } from 'ttag';

import { Button } from '@proton/atoms/Button/Button';
import { Tooltip } from '@proton/atoms/Tooltip/Tooltip';
import Field from '@proton/components/components/container/Field';
import Row from '@proton/components/components/container/Row';
import Label from '@proton/components/components/label/Label';
import LabelStack from '@proton/components/components/labelStack/LabelStack';
import useModalState from '@proton/components/components/modalTwo/useModalState';
import EditLabelModal from '@proton/components/containers/labels/modals/EditLabelModal';
import type { LabelModel } from '@proton/components/containers/labels/modals/EditLabelModal';
import { IcInfoCircle } from '@proton/icons/icons/IcInfoCircle';
import { IcPen } from '@proton/icons/icons/IcPen';

interface Props {
    label: Pick<LabelModel, 'Name' | 'Color' | 'Type'>;
    onEditLabel: (label: Pick<LabelModel, 'Name' | 'Color' | 'Type'>) => void;
}

const CustomizeMailImportModalLabel = ({ label, onEditLabel }: Props) => {
    const [editLabelModalProps, openEditLabelModal, renderEditLabelModal] = useModalState();

    return (
        <div className="mb-4 border-bottom items-center">
            <Row>
                <Label className="flex items-center">
                    {c('Label').t`Label messages as`}
                    <Tooltip title={c('Tooltip').t`Each imported email will have this label`}>
                        <IcInfoCircle className="ml-2" />
                    </Tooltip>
                </Label>
                <Field className="w-auto flex items-center flex-nowrap">
                    {label.Name && (
                        <LabelStack
                            labels={[
                                {
                                    name: label.Name,
                                    color: label.Color,
                                    title: label.Name,
                                },
                            ]}
                            className="max-w-full"
                        />
                    )}
                    <Tooltip title={c('Action').t`Edit label`}>
                        <Button
                            icon
                            shape="ghost"
                            className="shrink-0 ml-4"
                            onClick={() => openEditLabelModal(true)}
                            data-testid="CustomizeModal:editLabel"
                        >
                            <IcPen alt={c('Action').t`Edit label`} />
                        </Button>
                    </Tooltip>
                </Field>
                {renderEditLabelModal && (
                    <EditLabelModal
                        {...editLabelModalProps}
                        label={label}
                        type="label"
                        onCheckAvailable={({ Color, Name, Type }) => {
                            onEditLabel({ Color, Name, Type });
                        }}
                        mode="checkAvailable"
                    />
                )}
            </Row>
        </div>
    );
};

export default CustomizeMailImportModalLabel;
